import { React, PT, fetchApi, withRouter } from '@gasbuddy/react';
import { Segment, Header, Message, Button } from 'semantic-ui-react';

function getSplits({ transaction: { splits } }) {
  return splits;
}

class BaseTransactionTools extends React.Component {
  state = {
  }

  activateTransaction = (e) => {
    e.preventDefault();
    const { transaction, onChange } = this.props;
    this.setState({ loading: true }, async () => {
      const { status, body, error } = await fetchApi({
        url: '/devtools/transaction/activate',
        body: {
          transaction_id: transaction.transaction_id,
          account_id: transaction.account_id,
          context: {
            promptToken: transaction.provider_response.promptToken,
          },
        },
      });
      if (status === 200) {
        this.setState({ loading: false, error: null }, onChange);
      } else {
        this.setState({ loading: false, error: error || body });
      }
    });
  }

  backdateGasback = (e) => {
    e.preventDefault();
    const { transaction, onChange } = this.props;
    this.setState({ loading: true }, async () => {
      const { status, body, error } = await fetchApi({
        url: '/devtools/transaction/gasback/backdate',
        body: {
          transaction_id: transaction.transaction_id,
          back_date_days: 366,
        },
      });
      if (status === 200) {
        this.setState({ loading: false, error: null }, onChange);
      } else {
        this.setState({ loading: false, error: error || body });
      }
    });
  }

  canChargeBack = s => (
    s.counterparty === 'dwolla'
    && !(s.external_transaction_id || '').startsWith('chargeback-')
    && !getSplits(this.props).find(
      s2 => s2.external_transaction_id === `chargeback-${s.external_transaction_id}`,
    ));

  createChargeback = (e, s, returnCode) => {
    e.preventDefault();
    const { onChange } = this.props;
    this.setState({ loading: true }, async () => {
      const { status, body, error } = await fetchApi({
        url: '/devtools/transaction/chargeback',
        body: {
          href: s.external_transaction_id,
          code: returnCode,
          description: 'Insufficient Funds (FAKE)',
        },
      });
      if (status === 200) {
        this.setState({ loading: false, error: null }, onChange);
      } else {
        this.setState({ loading: false, error: error || body });
      }
    });
  }

  advanceGasback(e, split, status) {
    e.preventDefault();
    const { onChange } = this.props;
    this.setState({ loading: true }, async () => {
      await fetchApi({
        url: '/devtools/transaction/gasback',
        body: {
          status,
          partner: split.counterparty,
          external_transaction_id: split.external_transaction_id,
        },
      });
      this.setState({ loading: false, error: null }, onChange);
    });
  }

  renderGasback(transaction) {
    if (!transaction || !transaction.extra_data || !transaction.extra_data.type === 'gasback') {
      return null;
    }
    const gasback = transaction.splits.find(s => s.split_type === 'earnings');
    if (gasback && gasback.split_status === 'created') {
      return (
        <Button onClick={e => this.advanceGasback(e, gasback, 'locked')}>
          Lock in Gasback Transaction
        </Button>
      );
    } if (gasback && gasback.split_status === 'authorized') {
      return (
        <Button onClick={e => this.advanceGasback(e, gasback, 'settled')}>
          Settle Gasback Funds
        </Button>
      );
    } if (gasback && gasback.split_status === 'settled') {
      return (
        <Button onClick={e => this.backdateGasback(e)}>
          Backdate GasBack 1 year
        </Button>
      );
    }
    return null;
  }

  render() {
    const { transaction } = this.props;
    const { loading, error } = this.state;
    return (
      <div style={{ marginTop: 15 }}>
        <Header as="h3" block attached="top">
          Dev Tools
        </Header>
        <Segment attached loading={loading}>
          {error
            && (
            <Message error>
              Unable to create chargeback:
              <pre>{JSON.stringify(error, null, '\t')}</pre>
            </Message>
            )
          }
          {transaction && transaction.splits
            && transaction.splits.filter(this.canChargeBack).map(s => (
              <Button key={s.split_id} onClick={e => this.createChargeback(e, s, 'R01')}>
                Chargeback Split NSF #
                {transaction.splits.indexOf(s) + 1}
              </Button>
            ))}
          {transaction && transaction.splits
            && transaction.splits.filter(this.canChargeBack).map(s => (
              <Button key={s.split_id} onClick={e => this.createChargeback(e, s, 'R02')}>
                Chargeback Split Non-NSF #
                {transaction.splits.indexOf(s) + 1}
              </Button>
            ))}
          <br />
          {transaction && transaction.status === 'authorized' && transaction.provider_response
            && transaction.provider_response.promptToken
            && <Button onClick={this.activateTransaction}>Activate Pump</Button>
          }
          <br />
          {this.renderGasback(transaction)}
        </Segment>
      </div>
    );
  }
}

BaseTransactionTools.propTypes = {
  transaction: PT.shape({
    transaction_id: PT.number,
    account_id: PT.number,
    splits: PT.arrayOf(PT.shape({
      external_transaction_id: PT.string,
    })),
    provider_response: PT.shape({
      promptToken: PT.string,
    }),
  }),
  onChange: PT.func.isRequired,
};

BaseTransactionTools.defaultProps = {
  transaction: null,
};

export const TransactionTools = withRouter(BaseTransactionTools);
